import Vue from 'vue';
import { gsap, Quad, Quint } from 'gsap/all';

Vue.component('product-filter', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            filter: 'products',
            showProductFilters: false,
            inclusives: [],
            excludes: [],
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.productFiltersHolder = document.getElementById('products-filter-holder');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        onFilterCheck() {
            // map input values to an array
            this.inclusives = [];
            this.excludes = [];

            const checkboxes = [].slice.call(document.querySelectorAll('.filter-checkbox-input.groups'));
            for (let index = 0; index < checkboxes.length; index++) {
                const element = checkboxes[index];

                if (element.checked) {
                    this.inclusives.push(element.value);
                }
            }

            const allergiesCheckboxes = [].slice.call(document.querySelectorAll('.filter-checkbox-input.allergies'));
            for (let index = 0; index < allergiesCheckboxes.length; index++) {
                const element = allergiesCheckboxes[index];

                if (element.checked) {
                    this.excludes.push(element.value);
                }
            }

            EventBus.$emit('product-filter-change', {
                inclusives: this.inclusives,
                excludes: this.excludes,
            });
        },

        reset() {
            this.inclusives = [];
            this.excludes = [];

            const checkboxes = [].slice.call(document.querySelectorAll('.filter-checkbox-input'));
            for (let index = 0; index < checkboxes.length; index++) {
                const element = checkboxes[index];

                element.checked = false;
            }

            EventBus.$emit('product-filter-change', {
                inclusives: this.inclusives,
                excludes: this.excludes,
            });
        },

        close() {
            this.toggleProductFilters();
        },

        /**
        * Toggles the filters
        *
        * @return {Void}
        */
        toggleProductFilters(event) {
            this.showProductFilters = !this.showProductFilters;

            if (this.showProductFilters) {
                // Show
                gsap.to(this.productFiltersHolder, 0.8, {
                    height: 'auto',
                    ease: Quad.easeIn,
                });
                return;
            }

            // Hide
            gsap.to(this.productFiltersHolder, 0.8, {
                height: 0,
                ease: Quint.easeOut,
            });
        },

        /**
        * Toggles the filter
        *
        * @return {Void}
        */
        toggleProductFilter(event) {
            if (event.currentTarget.classList.contains('toggle-filter-group--active')) {
                // Hide
                gsap.to(event.currentTarget.nextElementSibling, 0.5, {
                    height: 0,
                    ease: Quint.easeOut,
                });
            } else {
                // Show
                gsap.to(event.currentTarget.nextElementSibling, 0.5, {
                    height: 'auto',
                    ease: Quad.easeIn,
                });
            }

            event.currentTarget.classList.toggle('toggle-filter-group--active');
        },

        /**
        * Toggles the filter
        *
        * @return {Void}
        */
        toggleListFilter(event) {
            const div1 = event.currentTarget.previousElementSibling;
            const btn = event.currentTarget;

            if (!div1.classList.contains('active')) {
                gsap.to(div1, 0.4, {
                    height: 0,
                    ease: Quad.easeIn,
                });

                div1.classList.add('active');
                btn.firstChild.classList.remove('hide');
                btn.lastElementChild.classList.add('hide');
            } else {
                gsap.to(div1, 0.4, {
                    height: 'auto',
                    ease: Quad.easeIn,
                });

                div1.classList.remove('active');
                btn.firstChild.classList.add('hide');
                btn.lastElementChild.classList.remove('hide');
            }
        },

    },
});
